export default "__VITE_ASSET__a3$s2cHQ__"